import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { styled } from "@mui/material/styles";
import {
  ListItemButton
} from "@biome-design-system/ui/ListItemButton";
import {
  ListItemText
} from "@biome-design-system/ui/ListItemText";
import { Typography } from "@biome-design-system/ui/Typography";
const DEFAULT_NO_RESULTS_LABEL = "No results";
const Answer = styled(ListItemButton, {
  name: "MuiFilterWizard",
  slot: "answer"
})(() => ({}));
const AnswerText = styled(ListItemText, {
  name: "MuiFilterWizard",
  slot: "answerText"
})(() => ({}));
const DefaultQuestionStepAnswerInner = ({
  answer,
  labels: { noResults: labelNoResults = DEFAULT_NO_RESULTS_LABEL } = {},
  onClick,
  ...restProps
}, ref) => {
  const noResults = Boolean(answer.count === 0);
  let answerSecondaryText = {};
  if (answer.secondary_text || noResults) {
    answerSecondaryText = {
      secondary: /* @__PURE__ */ jsxs(Fragment, { children: [
        Boolean(answer.secondary_text) && /* @__PURE__ */ jsx(
          Typography,
          {
            component: "span",
            variant: "subtitle2",
            children: answer.secondary_text
          }
        ),
        Boolean(noResults) && /* @__PURE__ */ jsx(
          Typography,
          {
            component: "span",
            "data-testid": "filter-wizard-no-results",
            variant: "subtitle2",
            children: labelNoResults
          }
        )
      ] }),
      secondaryTypographyProps: { component: "p", variant: "subtitle2" }
    };
  }
  return /* @__PURE__ */ jsx(
    Answer,
    {
      "data-testid": "filter-wizard-answer",
      ...restProps,
      alignItems: "flex-start",
      component: "li",
      disableGutters: true,
      disabled: noResults,
      onClick: noResults ? void 0 : onClick,
      ref,
      children: /* @__PURE__ */ jsx(
        AnswerText,
        {
          primary: answer.text,
          primaryTypographyProps: { component: "span", variant: "h6" },
          ...answerSecondaryText
        }
      )
    }
  );
};
const DefaultQuestionStepAnswer = forwardRef(
  DefaultQuestionStepAnswerInner
);
export {
  DefaultQuestionStepAnswer
};
